<div class="card card-default">

    <div class="panel-heading modal-header panel-header-padding panel-header-radius">
        <div class="col-sm-6">
            <div class="card-caption float-start"><a>{{project?.name}} Import </a></div>
        </div>
        <div class="col-sm-6">

            <button ngbTooltip="Return to Scenario List" class="btn btn-sm sk-btn-light float-end" type="button"
                (click)="showScenarioList()">Scenario List</button>
        </div>

    </div>

    <div class="panel-body panel-body-padding">

        <span>Upload a .zip file of project scenario data.<br/>
            <br/>
            The file must be the same format as exported by the DataStore.
            <br/>
        </span>

        <div class="row top-buffer" id="inputForm">
            <div class="col-sm-4">
                <input type="file" id="fileInput" class="form-control" (change)="onFileSelected($event)" aria-label="File input.">
                <small class="text-muted">.zip only.</small>
                <div class="sk-red sk-smaller">
                    <span *ngIf="!fileTypeOk">{{fileTypeErrorMessage}}</span>
                </div>
            </div>
            <div class="col-sm-2">
                <button class="btn btn-primary" type="button" (click)="submit()"
                    [disabled]="file == undefined || !fileTypeOk">Import</button>
            </div>
        </div>

    </div>

</div>
